// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"navMenuButton-module--menuButton--KAqss","menuIcon":"navMenuButton-module--menuIcon--Yp8Gm","menuLabel":"navMenuButton-module--menuLabel--2pT95"};